import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col, Card, Tabs, Tab, Container, Table, Modal } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';

import { dublinLocalToUtcISO, dublinEndTimeToUtcISO, dublinDateStr, dublinTimeStr } from '../../utils/dublinTime';


// If you're using react-icons, you can add:
import { FaTrash } from 'react-icons/fa';
// Or if you're using Bootstrap Icons:
import { BsTrash } from 'react-icons/bs';




import {
  CATEGORY_OF_STAFF,
  REASON_FOR_REQUEST,
  SHIFT_STATUS,
  LINE_STATUS,
  SPECIALS_REASON,       // ← ADD
} from '../../utils/enums';

import { useCreateShiftMutation } from '../../slices/shiftApiSlice';
import { useGetHospitalLocationsQuery } from '../../slices/hospitalLocationApiSlice';



const SPECIALS_TRIGGER_REASONS = ['1-1 special', 'Cohorts'];

// Shift time presets
const SHIFT_PRESETS = {
  'LD': { start: '08:00', end: '20:00', label: 'Long Day (8:00-20:00)' },
  'ND': { start: '20:00', end: '08:00', label: 'Night Duty (20:00-8:00)' },
  'AM': { start: '08:00', end: '16:00', label: 'Morning (8:00-16:00)' },
  'PM': { start: '14:00', end: '20:00', label: 'Afternoon (14:00-20:00)' },
  'TW': { start: '20:00', end: '00:00', label: 'Twilight (20:00-00:00)' },
  'ELD': { start: '07:30', end: '20:30', label: 'Extended Long Day (7:30-20:30)' },
  'ESCORT': { start: '08:00', end: '20:00', label: 'Escort (8:00-20:00)' },
};


// Reasons that restrict shift creation to within 48 hours
const FORTY_EIGHT_HOUR_REASONS = ['1-1 special', 'Cohorts'];


// Recurrence options
const RECURRENCE_OPTIONS = {
  NONE: { label: 'No Recurrence', value: 'NONE' },
  DAILY: { label: 'Daily', value: 'DAILY' },
  WEEKLY: { label: 'Weekly', value: 'WEEKLY' },
  BIWEEKLY: { label: 'Every 2 Weeks', value: 'BIWEEKLY' },
  MONTHLY: { label: 'Monthly', value: 'MONTHLY' },
};

// Days of week for recurrence
const DAYS_OF_WEEK = [
  { value: 'MON', label: 'Monday' },
  { value: 'TUE', label: 'Tuesday' },
  { value: 'WED', label: 'Wednesday' },
  { value: 'THU', label: 'Thursday' },
  { value: 'FRI', label: 'Friday' },
  { value: 'SAT', label: 'Saturday' },
  { value: 'SUN', label: 'Sunday' },
];

const ShiftCreateScreen = () => {
  const navigate = useNavigate();

  // Add these new states for confirmation modal
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [shiftList, setShiftList] = useState([]);
  const [originalShiftList, setOriginalShiftList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);

  // Basic shift information
  const [hospitalLocationId, setHospitalLocationId] = useState('');
  const [wardDepartmentArea, setWardDepartmentArea] = useState('');
  const [reasonForRequest, setReasonForRequest] = useState('');
  const [reasonForRequestDetails, setReasonForRequestDetails] = useState('');
  const [categoryOfStaff, setCategoryOfStaff] = useState('');
  const [escort, setEscort] = useState(false);
  const [special, setSpecial] = useState(false);
  const [eccNumber, setEccNumber] = useState('');
  const [specialRequirements, setSpecialRequirements] = useState('');
  const [comments, setComments] = useState('');
  //const [numberOfShifts, setNumberOfShifts] = useState(1);
 // Replace the existing numberOfShifts state with this:
const [shiftsPerDay, setShiftsPerDay] = useState({
  MON: 1,
  TUE: 1,
  WED: 1,
  THU: 1,
  FRI: 1,
  SAT: 1,
  SUN: 1
});

  const [selectedShifts, setSelectedShifts] = useState([]);


  // Date and time
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [startTime, setStartTime] = useState('08:00');
  const [endTime, setEndTime] = useState('16:00');
  const [selectedPreset, setSelectedPreset] = useState('AM');

  // Recurrence settings
  const [recurrenceType, setRecurrenceType] = useState('NONE');
  const [recurrenceEndDate, setRecurrenceEndDate] = useState('');
  const [recurrenceOccurrences, setRecurrenceOccurrences] = useState(1);
  const [selectedDays, setSelectedDays] = useState(['MON', 'TUE', 'WED', 'THU', 'FRI']);

  const [activeTab, setActiveTab] = useState('basic');

const [isOvertime, setIsOvertime] = useState(false);

// Add a state to track if form is submitting
const [isSubmitting, setIsSubmitting] = useState(false);

const [specialsReason, setSpecialsReason] = useState('');


  const {
    data: hospitalLocations,
    isLoading: loadingLocations,
    error: errorLocations,
  } = useGetHospitalLocationsQuery();

  const [createShift, { isLoading: loadingCreate }] = useCreateShiftMutation();

  // Initialize dates when component mounts
  // Initialize dates when component mounts
useEffect(() => {
  const today = new Date();
  //const todayStr = today.toISOString().split('T')[0];
  const todayStr = toLocalDateStr(today);
  setStartDate(todayStr);
  setEndDate(todayStr);
  
  // Set recurrence end date to the Sunday after the end date
  // For now, end date is today, so find the coming Sunday
  const sundayAfterEndDate = new Date(today);
  const daysUntilSunday = (7 - today.getDay()) % 7; // Get days until next Sunday (0 if today is Sunday)
  sundayAfterEndDate.setDate(today.getDate() + (daysUntilSunday === 0 ? 7 : daysUntilSunday));
  //setRecurrenceEndDate(sundayAfterEndDate.toISOString().split('T')[0]);
  setRecurrenceEndDate(toLocalDateStr(sundayAfterEndDate));
}, []);

// Update recurrence end date to the Sunday after the selected end date
useEffect(() => {
  if (endDate) {
    const endDateObj = new Date(endDate);
    const sundayAfterEndDate = new Date(endDateObj);
    const daysUntilSunday = (7 - endDateObj.getDay()) % 7; // Get days until next Sunday
    
    // If end date is Sunday, we want next Sunday (add 7 days)
    // If end date is any other day, add days until Sunday
    sundayAfterEndDate.setDate(endDateObj.getDate() + (daysUntilSunday === 0 ? 7 : daysUntilSunday));
    
    //setRecurrenceEndDate(sundayAfterEndDate.toISOString().split('T')[0]);
    setRecurrenceEndDate(toLocalDateStr(sundayAfterEndDate));
  }
}, [endDate]);

  // Update end date when start date changes
  useEffect(() => {
    if (startDate && !endDate) {
      setEndDate(startDate);
    }
  }, [startDate, endDate]);

  // Apply preset times when selected
  useEffect(() => {
    const preset = SHIFT_PRESETS[selectedPreset];
    if (preset) {
      setStartTime(preset.start);
      setEndTime(preset.end);
      
      // Update escort checkbox based on preset
      if (selectedPreset === 'ESCORT') {
        setEscort(true);
      }
    }
  }, [selectedPreset]);

  // Handle day selection for recurrence
  const handleDayToggle = (dayValue) => {
    if (selectedDays.includes(dayValue)) {
      setSelectedDays(selectedDays.filter(day => day !== dayValue));
    } else {
      setSelectedDays([...selectedDays, dayValue]);
    }
  };

  //helper
  const toLocalDateStr = (d) => {
  const yyyy = d.getFullYear();
  const mm   = String(d.getMonth() + 1).padStart(2, '0');
  const dd   = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};



  // Handle updating shifts per day for a specific day
const handleShiftsPerDayChange = (day, value) => {
  const numValue = Math.max(0, parseInt(value) || 0);
  setShiftsPerDay(prev => ({
    ...prev,
    [day]: numValue
  }));
};

const applyTimeRestriction = (shifts) => {
  const isRestricted = FORTY_EIGHT_HOUR_REASONS.some(
    (r) => reasonForRequest.toLowerCase() === r.toLowerCase()
  );
  if (!isRestricted) return shifts;

  const now = new Date();
  const isFriday = now.getDay() === 5;  // 0=Sun, 5=Fri, 6=Sat
  //const windowHours = isFriday ? 72 : 48;
  const windowHours = isFriday ? 720 :720;   /// extend for now 
  const cutoff = new Date(now.getTime() + windowHours * 60 * 60 * 1000);

  return shifts.filter((shift) => {
    const shiftStart = new Date(`${shift.startDate}T${shift.startTime}`);
    return shiftStart <= cutoff;
  });
};


  // Generate all shift dates based on recurrence settings
  // Generate all shift dates based on recurrence settings
// Generate all shift dates based on recurrence settings
// Generate all shift dates based on recurrence settings
// Generate all shift dates based on recurrence settings
const generateShiftDates = () => {
  const shifts = [];
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  console.log('=== GENERATE SHIFT DATES START ===');
  console.log('Input parameters:', {
    recurrenceType,
    selectedDays: [...selectedDays],
    shiftsPerDay,
    startDate,
    endDate,
    startTime,
    endTime,
    recurrenceEndDate,
    recurrenceOccurrences
  });
  
  // For NON-RECURRING shifts
  if (recurrenceType === 'NONE') {
    // For non-recurring, use Monday's shift count as default (or first selected day)
    const defaultShifts = shiftsPerDay.MON || 1;
    for (let i = 0; i < defaultShifts; i++) {
      shifts.push({
        id: `${startDate}-${startTime}-${endTime}-${i}-${Date.now()}`,
        startDate: startDate,
        endDate: endDate,
        startTime,
        endTime,
        shiftNumber: i + 1
      });
    }
    return shifts;
  }
  
  // Map day values for weekly recurrences
  const dayMap = {
    'SUN': 0, 'MON': 1, 'TUE': 2, 'WED': 3, 
    'THU': 4, 'FRI': 5, 'SAT': 6
  };
  
  // For recurrence, we need the day numbers for filtering
  let selectedDayNumbers;
  
  if (recurrenceType === 'DAILY' || recurrenceType === 'WEEKLY' || recurrenceType === 'BIWEEKLY') {
    // For daily/weekly recurrence, use selected days
    selectedDayNumbers = selectedDays.map(day => dayMap[day]);
  } else {
    // For MONTHLY recurrence, include all days
    selectedDayNumbers = [0, 1, 2, 3, 4, 5, 6];
  }
  
  console.log('Selected day numbers:', selectedDayNumbers);
  
  let totalOccurrences = 0;
  const maxOccurrences = parseInt(recurrenceOccurrences);
  const recurrenceEnd = recurrenceEndDate ? new Date(recurrenceEndDate) : null;
  
  console.log('Max occurrences:', maxOccurrences);
  console.log('Recurrence end date:', recurrenceEnd);
  
  // Helper to get the day key from date
  const getDayKeyFromDate = (date) => {
    const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    return days[date.getDay()];
  };
  
  // Helper to get number of shifts for a given date
  const getShiftsCountForDate = (date) => {
    const dayKey = getDayKeyFromDate(date);
    return shiftsPerDay[dayKey] || 0;
  };
  
  // DAILY recurrence with day filtering and per-day shift counts
  if (recurrenceType === 'DAILY') {
    console.log('Starting DAILY recurrence calculation with per-day shift counts...');
    let currentDate = new Date(start);
    
    while (true) {
      // Check stop conditions
      if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) {
        console.log(`Stopping: reached max occurrences (${maxOccurrences})`);
        break;
      }
      if (recurrenceEnd && currentDate > recurrenceEnd) {
        console.log('Stopping: passed recurrence end date');
        break;
      }
      
      const currentDayOfWeek = currentDate.getDay();
      const dayKey = getDayKeyFromDate(currentDate);
      const shiftsForThisDay = shiftsPerDay[dayKey] || 0;
      
      // Only create shifts if day is selected AND has shifts > 0
      if (selectedDayNumbers.includes(currentDayOfWeek) && shiftsForThisDay > 0) {
        //const dateStr = currentDate.toISOString().split('T')[0];
        const dateStr = toLocalDateStr(currentDate)
        console.log(`Creating ${shiftsForThisDay} shift(s) for ${dateStr} (${dayKey})`);
        
        // Create the shifts for this day
        for (let i = 0; i < shiftsForThisDay; i++) {
          shifts.push({
            id: `${dateStr}-${startTime}-${endTime}-${i}-${totalOccurrences}-${Date.now()}`,
            startDate: dateStr,
            endDate: dateStr,
            startTime,
            endTime,
            dayOfWeek: dayKey,
            shiftIndex: i + 1
          });
          totalOccurrences++;
          
          console.log(`  Created shift ${totalOccurrences}: ${dateStr} ${startTime}-${endTime}`);
          
          if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) {
            console.log(`  Stopping: reached max occurrences`);
            break;
          }
        }
      } else if (selectedDayNumbers.includes(currentDayOfWeek)) {
        console.log(`Skipping ${currentDate.toDateString()} - shifts per day set to 0`);
      } else {
        console.log(`Skipping ${currentDate.toDateString()} - not in selected days`);
      }
      
      // Move to next day
      currentDate.setDate(currentDate.getDate() + 1);
      
      // Safety limit
      if (totalOccurrences > 1000) {
        console.log('Safety limit: stopped after 1000 shifts');
        break;
      }
    }
  }
  
  // WEEKLY recurrence with per-day shift counts
  else if (recurrenceType === 'WEEKLY') {
    let currentWeekStart = new Date(start);
    let weekCount = 0;
    
    console.log('Starting WEEKLY recurrence calculation with per-day shift counts...');
    
    while (true) {
      // Check stop conditions
      if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) {
        console.log(`Stopping: reached max occurrences (${maxOccurrences})`);
        break;
      }
      if (recurrenceEnd && currentWeekStart > recurrenceEnd) {
        console.log('Stopping: passed recurrence end date');
        break;
      }
      
      console.log(`\nWeek ${weekCount + 1} (starting ${currentWeekStart.toDateString()}):`);
      
      // For each selected day in this week
      for (const dayNumber of selectedDayNumbers) {
        // Calculate date for this specific day
        const dayDate = new Date(currentWeekStart);
        const currentDayOfWeek = dayDate.getDay();
        const daysToAdd = (dayNumber - currentDayOfWeek + 7) % 7;
        dayDate.setDate(dayDate.getDate() + daysToAdd);
        
        // Skip if before overall start date
        if (dayDate < start) {
          console.log(`  Skipping ${dayDate.toDateString()}: before start date`);
          continue;
        }
        
        // Check if we should stop
        if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) break;
        if (recurrenceEnd && dayDate > recurrenceEnd) {
          console.log(`  Stopping: ${dayDate.toDateString()} is after recurrence end date`);
          break;
        }
        
        const dayKey = getDayKeyFromDate(dayDate);
        const shiftsForThisDay = shiftsPerDay[dayKey] || 0;
        
        if (shiftsForThisDay > 0) {
          //const dateStr = dayDate.toISOString().split('T')[0];
          const dateStr = toLocalDateStr(dayDate)
          console.log(`  Creating ${shiftsForThisDay} shift(s) for ${dateStr} (${dayKey})`);
          
          // Create the shifts for this day
          for (let i = 0; i < shiftsForThisDay; i++) {
            shifts.push({
              id: `${dateStr}-${startTime}-${endTime}-${i}-${totalOccurrences}-${Date.now()}`,
              startDate: dateStr,
              endDate: dateStr,
              startTime,
              endTime,
              week: weekCount + 1,
              dayOfWeek: dayKey,
              shiftIndex: i + 1
            });
            totalOccurrences++;
            
            console.log(`    Created shift ${totalOccurrences}: ${dateStr} ${startTime}-${endTime}`);
            
            if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) {
              console.log(`    Stopping: reached max occurrences`);
              break;
            }
          }
        } else {
          console.log(`  Skipping ${dayDate.toDateString()} - shifts per day set to 0`);
        }
        
        if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) break;
      }
      
      // Move to next week
      currentWeekStart.setDate(currentWeekStart.getDate() + 7);
      weekCount++;
      
      // Safety limit
      if (weekCount > 100) {
        console.log('Safety limit: stopped after 100 weeks');
        break;
      }
    }
  }
  
  // BIWEEKLY recurrence with per-day shift counts
  else if (recurrenceType === 'BIWEEKLY') {
    let currentWeekStart = new Date(start);
    let weekCount = 0;
    
    console.log('Starting BIWEEKLY recurrence calculation with per-day shift counts...');
    
    while (true) {
      // Check stop conditions
      if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) {
        console.log(`Stopping: reached max occurrences (${maxOccurrences})`);
        break;
      }
      if (recurrenceEnd && currentWeekStart > recurrenceEnd) {
        console.log('Stopping: passed recurrence end date');
        break;
      }
      
      console.log(`\nWeek ${weekCount + 1} (starting ${currentWeekStart.toDateString()}):`);
      
      // Only process every 2 weeks
      if (weekCount % 2 === 0) {
        // For each selected day in this week
        for (const dayNumber of selectedDayNumbers) {
          // Calculate date for this specific day
          const dayDate = new Date(currentWeekStart);
          const currentDayOfWeek = dayDate.getDay();
          const daysToAdd = (dayNumber - currentDayOfWeek + 7) % 7;
          dayDate.setDate(dayDate.getDate() + daysToAdd);
          
          // Skip if before overall start date
          if (dayDate < start) {
            console.log(`  Skipping ${dayDate.toDateString()}: before start date`);
            continue;
          }
          
          // Check if we should stop
          if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) break;
          if (recurrenceEnd && dayDate > recurrenceEnd) {
            console.log(`  Stopping: ${dayDate.toDateString()} is after recurrence end date`);
            break;
          }
          
          const dayKey = getDayKeyFromDate(dayDate);
          const shiftsForThisDay = shiftsPerDay[dayKey] || 0;
          
          if (shiftsForThisDay > 0) {
           // const dateStr = dayDate.toISOString().split('T')[0];
            const dateStr = toLocalDateStr(dayDate);
            console.log(`  Creating ${shiftsForThisDay} shift(s) for ${dateStr} (${dayKey})`);
            
            // Create the shifts for this day
            for (let i = 0; i < shiftsForThisDay; i++) {
              shifts.push({
                id: `${dateStr}-${startTime}-${endTime}-${i}-${totalOccurrences}-${Date.now()}`,
                startDate: dateStr,
                endDate: dateStr,
                startTime,
                endTime,
                week: Math.floor(weekCount / 2) + 1,
                dayOfWeek: dayKey,
                shiftIndex: i + 1
              });
              totalOccurrences++;
              
              console.log(`    Created shift ${totalOccurrences}: ${dateStr} ${startTime}-${endTime}`);
              
              if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) {
                console.log(`    Stopping: reached max occurrences`);
                break;
              }
            }
          } else {
            console.log(`  Skipping ${dayDate.toDateString()} - shifts per day set to 0`);
          }
          
          if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) break;
        }
      }
      
      // Move to next week
      currentWeekStart.setDate(currentWeekStart.getDate() + 7);
      weekCount++;
      
      // Safety limit
      if (weekCount > 200) {
        console.log('Safety limit: stopped after 200 weeks');
        break;
      }
    }
  }
  
  // MONTHLY recurrence with per-day shift counts
  else if (recurrenceType === 'MONTHLY') {
    console.log('Starting MONTHLY recurrence calculation with per-day shift counts...');
    let currentDate = new Date(start);
    let monthCount = 0;
    
    while (true) {
      // Check stop conditions
      if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) {
        console.log(`Stopping: reached max occurrences (${maxOccurrences})`);
        break;
      }
      if (recurrenceEnd && currentDate > recurrenceEnd) {
        console.log('Stopping: passed recurrence end date');
        break;
      }
      
      const dayKey = getDayKeyFromDate(currentDate);
      const shiftsForThisDay = shiftsPerDay[dayKey] || 0;
      
      if (shiftsForThisDay > 0) {
        //const dateStr = currentDate.toISOString().split('T')[0];
        const dateStr = toLocalDateStr(currentDate)
        console.log(`Creating ${shiftsForThisDay} shift(s) for ${dateStr} (${dayKey})`);
        
        // Create the shifts for this day
        for (let i = 0; i < shiftsForThisDay; i++) {
          shifts.push({
            id: `${dateStr}-${startTime}-${endTime}-${i}-${totalOccurrences}-${Date.now()}`,
            startDate: dateStr,
            endDate: dateStr,
            startTime,
            endTime,
            monthIndex: monthCount + 1,
            dayOfWeek: dayKey,
            shiftIndex: i + 1
          });
          totalOccurrences++;
          
          console.log(`  Created shift ${totalOccurrences}: ${dateStr} ${startTime}-${endTime}`);
          
          if (maxOccurrences > 0 && totalOccurrences >= maxOccurrences) {
            console.log(`  Stopping: reached max occurrences`);
            break;
          }
        }
      } else {
        console.log(`Skipping ${currentDate.toDateString()} - shifts per day set to 0`);
      }
      
      // Move to next month (same day of month)
      currentDate.setMonth(currentDate.getMonth() + 1);
      monthCount++;
      
      // Safety limit
      if (monthCount > 60) {
        console.log('Safety limit: stopped after 60 months');
        break;
      }
    }
  }
  
  console.log(`\n=== FINAL RESULT ===`);
  console.log(`Total shifts generated: ${shifts.length}`);
  console.log('All shifts:', shifts.map((s, idx) => `${idx + 1}. ${s.startDate} ${s.startTime}-${s.endTime} (${s.dayOfWeek})`));
  console.log('=== GENERATE SHIFT DATES END ===\n');
  
  return shifts;
};

// Helper function to ensure proper date formatting
const formatDateForShift = (dateStr) => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    // If invalid date, return today's date
    //return new Date().toISOString().split('T')[0];
    return toLocalDateStr(new Date());
  }
  return dateStr;
};

// Update handleShiftUpdate to use this formatter
// Update the handleShiftUpdate function
// Update handleShiftUpdate to use this helper
const handleShiftUpdate = (index, field, value) => {
  const updatedShifts = [...shiftList];
  
  // Update the field
  updatedShifts[index] = {
    ...updatedShifts[index],
    [field]: value
  };
  
  // CRITICAL FIX: If start date changes, update end date appropriately
  if (field === 'startDate') {
    const isOvernight = updatedShifts[index].startTime > updatedShifts[index].endTime;
    
    if (isOvernight) {
      // For overnight shifts, end date should be next day
      const nextDay = new Date(value);
      nextDay.setDate(nextDay.getDate() + 1);
      //updatedShifts[index].endDate = nextDay.toISOString().split('T')[0];
      updatedShifts[index].endDate = toLocalDateStr(nextDay);
    } else {
      // For normal shifts, end date is same as start date
      updatedShifts[index].endDate = value;
    }
  }
  
  // If end time becomes earlier than start time on same day, mark as overnight
  if (field === 'startTime' || field === 'endTime') {
    const shift = updatedShifts[index];
    
    // Check if this creates an overnight shift pattern
    if (shift.startTime > shift.endTime && shift.startDate === shift.endDate) {
      // It's now an overnight shift - adjust end date to next day
      const endDate = new Date(shift.endDate);
      endDate.setDate(endDate.getDate() + 1);
      //updatedShifts[index].endDate = endDate.toISOString().split('T')[0];
      updatedShifts[index].endDate = toLocalDateStr(endDate);
    } else if (shift.startTime <= shift.endTime && shift.startDate !== shift.endDate) {
      // If times are normal but dates are different, make dates same
      updatedShifts[index].endDate = shift.startDate;
    }
  }
  
  // Sort and update
  const sortedShifts = sortShiftsByDate(updatedShifts);
  setShiftList(sortedShifts);
  setIsEditing(true);
};


  // Combine date and time into ISO strings
  // Combine date and time into ISO strings with validation
const combineDateTime = (dateStr, timeStr) => {
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date');
    }
    return new Date(`${dateStr}T${timeStr}`).toISOString();
  } catch (error) {
    console.error('Error combining date/time:', error);
    // Fallback to current date
    //return new Date(`${new Date().toISOString().split('T')[0]}T${timeStr}`).toISOString();
    return new Date(`${toLocalDateStr(new Date())}T${timeStr}`).toISOString();
  }
};


// Helper to auto-adjust end date for overnight shifts
const autoAdjustOvernightShift = (shift) => {
  const updatedShift = { ...shift };
  
  // Check if this is an overnight shift (end time earlier than start time on same day)
  if (updatedShift.startTime > updatedShift.endTime && 
      updatedShift.startDate === updatedShift.endDate) {
    // Set end date to next day
    const endDate = new Date(updatedShift.endDate);
    endDate.setDate(endDate.getDate() + 1);
    //updatedShift.endDate = endDate.toISOString().split('T')[0];
    updatedShift.endDate = toLocalDateStr(endDate);
  }
  
  return updatedShift;
};

  // Calculate total shifts that will be created
  const calculateTotalShifts = () => {
  const shiftDates = applyTimeRestriction(generateShiftDates());
  return shiftDates.length;
};

  const submitHandler = async (e) => {
  e.preventDefault();

 //console.log('=== SUBMIT HANDLER START ===');

  if (isSubmitting) {
    toast.warning('Please wait, form is already submitting...');
    return;
  }
  
  // Validate required fields first
  const requiredFields = [
    { value: hospitalLocationId, message: 'Please select a hospital location' },
    { value: categoryOfStaff, message: 'Please select category of staff' },
    { value: reasonForRequest, message: 'Please select reason for request' },
    { value: startDate, message: 'Please select start date' },
    { value: endDate, message: 'Please select end date' },
  ];


  // Validate specialsReason is filled when required
  if (['1-1 special', 'Cohorts'].some(r => reasonForRequest.toLowerCase() === r.toLowerCase())
      && !specialsReason) {
    toast.error('Please select a Specials / Cohorts reason');
    return;
  }
  
  for (const field of requiredFields) {
    if (!field.value) {
      toast.error(field.message);
      return;
    }
  }
  
  // Validate date range
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (end < start) {
    toast.error('End date cannot be before start date');
    return;
  }
  
  const totalShifts = calculateTotalShifts();
  
  if (totalShifts === 0) {
    toast.error('No shifts to create based on current settings');
    return;
  }
  
  if (totalShifts > 50) {
    toast.error(`Cannot create more than 50 shifts at once. You selected ${totalShifts} shifts.`);
    return;
  }
  
  // Show confirmation modal
  prepareShiftsForConfirmation();
  
 //console.log('=== SUBMIT HANDLER END ===');
};


// Add this function to sort shifts by date and time
const sortShiftsByDate = (shifts) => {
  return [...shifts].sort((a, b) => {
    // First compare dates
    const dateCompare = a.startDate.localeCompare(b.startDate);
    if (dateCompare !== 0) return dateCompare;
    
    // If same date, compare start times
    return a.startTime.localeCompare(b.startTime);
  });
};

// Update the prepareShiftsForConfirmation function
const prepareShiftsForConfirmation = () => {
  const rawShifts = generateShiftDates();
  const filtered = applyTimeRestriction(rawShifts);

  if (filtered.length < rawShifts.length) {
  const dropped = rawShifts.length - filtered.length;
  //const windowHours = new Date().getDay() === 5 ? 72 : 48;
  const windowHours = new Date().getDay() === 5 ? 720 : 720;
  toast.warning(
    `${dropped} shift${dropped > 1 ? 's' : ''} removed — "${reasonForRequest}" requests are limited to the next ${windowHours} hours${new Date().getDay() === 5 ? ' (Friday extension applied)' : ''}.`
  );
}

  const shiftsWithIds = filtered.map((shift, index) => ({
    ...shift,
    id: shift.id || `${shift.startDate}-${shift.startTime}-${shift.endTime}-${index}-${Date.now()}`,
  }));

  const sortedShifts = sortShiftsByDate(shiftsWithIds);
  setShiftList(sortedShifts);
  setOriginalShiftList(JSON.parse(JSON.stringify(sortedShifts)));
  setSelectedShifts([]);
  setShowConfirmation(true);
  setIsEditing(false);
  setSaveSuccess(false);
};


// Function to create shifts after confirmation
// Function to create shifts after confirmation
// Update the createShifts function - fix the validation part:
// Function to create shifts after confirmation
const createShifts = async () => {
  setIsSubmitting(true);
  setSaveSuccess(false);
  
  try {
    console.log(`Will attempt to create ${shiftList.length} shifts`);
    
    // Track created shifts
    const createdShiftIds = [];
    const failedShifts = [];
    
    // Create shifts one by one
    for (let i = 0; i < shiftList.length; i++) {
      const shift = shiftList[i];
      
      // Validate the shift
      const shiftIsValid = validateShift(shift);
      
      if (!shiftIsValid) {
        console.warn(`Skipping invalid shift ${i + 1}: End time not after start time`);
        failedShifts.push({
          index: i + 1,
          reason: 'Invalid time (end must be after start)',
          shift
        });
        continue;
      }
      
      console.log(`Creating shift ${i + 1}/${shiftList.length}: ${shift.startDate} ${shift.startTime}-${shift.endTime}`);
      
      try {
        // CRITICAL FIX: Handle overnight shifts correctly
        let startDateForShift = shift.startDate;
        let endDateForShift = shift.endDate;
        
        // Create date objects for comparison
        const startDateTime = new Date(`${shift.startDate}T${shift.startTime}`);
        let endDateTime = new Date(`${shift.endDate}T${shift.endTime}`);
        
        // Check if it's an overnight shift (end time earlier than start time)
        const isOvernight = shift.startTime > shift.endTime;
        
        if (isOvernight) {
          // For overnight shifts, the end date should be the next day
          // But we need to preserve the original start date for the shift record
          const nextDay = new Date(shift.startDate);
          nextDay.setDate(nextDay.getDate() + 1);
          //endDateForShift = nextDay.toISOString().split('T')[0];
          endDateForShift = toLocalDateStr(nextDay);
          
          console.log(`  Overnight shift detected. Original: ${shift.startDate} to ${shift.endDate}`);
          console.log(`  Adjusted: Start date remains ${startDateForShift}, End date set to ${endDateForShift}`);
          
          // Recreate endDateTime with the corrected date
          endDateTime = new Date(`${endDateForShift}T${shift.endTime}`);
        } else {
          // For normal shifts, ensure end date is same as start date if not already
          // This handles cases where end date might have been incorrectly set
          endDateForShift = shift.startDate;
        }
        
        // Use the shift's specific data
        const shiftData = {
          // For overnight shifts, the start date should be the day the shift starts
          // The end date in the database should be the day it ends (next day for overnight)
          startDateTime: dublinLocalToUtcISO(startDateForShift, shift.startTime),
          endDateTime: dublinLocalToUtcISO(endDateForShift, shift.endTime),
          hospitalLocationId,
          wardDepartmentArea: wardDepartmentArea || '',
          reasonForRequest,
          reasonForRequestDetails,
          specialsReason,          // ← ADD THIS
          categoryOfStaff,
          escort,
          special,
          eccNumber,
          status: 'Open',
          lineStatus: 'Open',
          specialRequirements,
          comments,
          isOvertime,
          numberOfShifts: 1,
        };
        
        console.log('Shift data being sent:', shiftData);
        
        const result = await createShift(shiftData).unwrap();
        
        if (result._id) {
          createdShiftIds.push(result._id);
          console.log(`  Success! Shift ID: ${result._id}`);
        } else if (result.shifts) {
          result.shifts.forEach(s => {
            if (s._id) createdShiftIds.push(s._id);
          });
          console.log(`  Success! Created ${result.shifts.length} shift(s)`);
        } else if (result.id) {
          createdShiftIds.push(result.id);
          console.log(`  Success! Shift ID: ${result.id}`);
        }
        
        // Small delay between API calls
        if (i < shiftList.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      } catch (err) {
        console.error(`Failed to create shift ${i + 1}:`, err);
        failedShifts.push({
          index: i + 1,
          reason: err?.data?.message || err.error || 'API error',
          shift
        });
      }
    }
    
    console.log(`Successfully created ${createdShiftIds.length} out of ${shiftList.length} shifts`);
    
    if (failedShifts.length > 0) {
      console.warn('Failed shifts:', failedShifts);
      
      failedShifts.forEach(failed => {
        console.error(`Shift ${failed.index} failed: ${failed.reason}`);
        console.error('Shift data:', failed.shift);
      });
    }
    
    if (createdShiftIds.length > 0) {
      setSaveSuccess(true);
      
      let successMessage = `Successfully created ${createdShiftIds.length} shift${createdShiftIds.length > 1 ? 's' : ''}`;
      if (failedShifts.length > 0) {
        successMessage += ` (${failedShifts.length} failed)`;
      }
      
      toast.success(successMessage, {
        autoClose: 5000
      });
      
      if (failedShifts.length > 0) {
        toast.warning(
          `${failedShifts.length} shift${failedShifts.length > 1 ? 's' : ''} failed to create. Check console for details.`,
          { autoClose: 7000 }
        );
      }
      
      // Query the database to verify the Sunday shifts were created
      console.log('Created shift IDs:', createdShiftIds);
      
      setTimeout(() => {
        setShowConfirmation(false);
        navigate('/admin/shifts');
      }, 2000);
    } else {
      if (failedShifts.length > 0) {
        const errorMessages = failedShifts.map(f => f.reason).filter((v, i, a) => a.indexOf(v) === i);
        toast.error(`Failed to create shifts: ${errorMessages.join(', ')}`);
      } else {
        toast.error('Failed to create any shifts. Please check your shift data.');
      }
      setIsSubmitting(false);
    }
    
  } catch (err) {
    console.error('Error in createShifts:', err);
    
    if (err?.data) {
      console.error('API Error Data:', err.data);
      console.error('API Error Status:', err.status);
    }
    
    toast.error(err?.data?.message || err.error || 'Failed to create shifts. Check console for details.');
    setIsSubmitting(false);
  }
};

// Handle removing a shift from the list
const handleRemoveShift = (index) => {
  const updatedShifts = [...shiftList];
  updatedShifts.splice(index, 1);
  setShiftList(updatedShifts);
  setIsEditing(true);
  
  toast.info(`Shift removed. ${updatedShifts.length} shifts remaining.`);
};

// Comprehensive shift validation
const validateShiftOld = (shift) => {
  const errors = [];
  
  // Check if dates are valid
  const startDateValid = !isNaN(new Date(shift.startDate).getTime());
  const endDateValid = !isNaN(new Date(shift.endDate).getTime());
  
  if (!startDateValid) errors.push('Invalid start date');
  if (!endDateValid) errors.push('Invalid end date');
  
  // Check if times are valid
  const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
  if (!timeRegex.test(shift.startTime)) errors.push('Invalid start time');
  if (!timeRegex.test(shift.endTime)) errors.push('Invalid end time');
  
  // Check if end is after start
  if (startDateValid && endDateValid && timeRegex.test(shift.startTime) && timeRegex.test(shift.endTime)) {
    const start = new Date(`${shift.startDate}T${shift.startTime}`);
    const end = new Date(`${shift.endDate}T${shift.endTime}`);
    
    if (end <= start) {
      errors.push('End date/time must be after start date/time');
    }
  }

  
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Add this with your other helper functions, before the render
// Fix the validateShift function to handle overnight shifts properly
const validateShift = (shift) => {
  const start = new Date(`${shift.startDate}T${shift.startTime}`);
  const end = new Date(`${shift.endDate}T${shift.endTime}`);
  
  // If end is before start, check if it's an overnight shift
  if (end < start) {
    // Check if it's the same day (true overnight shift)
    if (shift.startDate === shift.endDate) {
      // This is an overnight shift on the same calendar day
      // Create a new end date for the next day
      const adjustedEnd = new Date(end);
      adjustedEnd.setDate(adjustedEnd.getDate() + 1);
      return adjustedEnd > start;
    } else {
      // Different dates but end is before start - invalid
      return false;
    }
  }
  
  return end > start;
};

// Handle removing multiple shifts
const handleRemoveMultiple = (indexes) => {
  const updatedShifts = shiftList.filter((_, index) => !indexes.includes(index));
  setShiftList(updatedShifts);
  setIsEditing(true);
  
  toast.info(`${indexes.length} shift(s) removed. ${updatedShifts.length} shifts remaining.`);
};


// Handle shift selection
const handleShiftSelect = (index) => {
  if (selectedShifts.includes(index)) {
    setSelectedShifts(selectedShifts.filter(i => i !== index));
  } else {
    setSelectedShifts([...selectedShifts, index]);
  }
};

// Select all shifts
const handleSelectAll = () => {
  if (selectedShifts.length === shiftList.length) {
    setSelectedShifts([]);
  } else {
    setSelectedShifts(shiftList.map((_, index) => index));
  }
};

// Clear all selections
const handleClearSelection = () => {
  setSelectedShifts([]);
};

// Add a helper function to check if a shift is overnight
const isOvernightShift = (shift) => {
  return shift.startTime > shift.endTime && shift.startDate === shift.endDate;
};

// Reset to original values
const handleResetChanges = () => {
  setShiftList(JSON.parse(JSON.stringify(originalShiftList)));
  setIsEditing(false);
};

// Calculate duration for display
// Calculate duration for display - fixed for multi-day shifts
// Update the calculateDuration function to handle overnight shifts properly
const calculateDuration = (startDate, startTime, endDate, endTime) => {
  const start = new Date(`${startDate}T${startTime}`);
  const end = new Date(`${endDate}T${endTime}`);
  
  let adjustedEnd = new Date(end);
  
  // If end is before start on same day, it's an overnight shift
  if (end < start && startDate === endDate) {
    adjustedEnd.setDate(adjustedEnd.getDate() + 1);
  }
  
  const durationMs = adjustedEnd - start;
  const hours = Math.floor(durationMs / (1000 * 60 * 60));
  const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
  
  if (hours === 0 && minutes === 0) return '0h';
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};

// Format day of week
const getDayOfWeek = (dateStr) => {
  const date = new Date(dateStr);
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days[date.getDay()];
};


// Add this helper function with your other helper functions
const isShiftInvalid = (shift) => {
  // Overnight shifts are valid
  const isOvernight = shift.startTime > shift.endTime && shift.startDate === shift.endDate;
  if (isOvernight) return false;
  
  // Check if end is after start
  const start = new Date(`${shift.startDate}T${shift.startTime}`);
  const end = new Date(`${shift.endDate}T${shift.endTime}`);
  return end <= start;
};

const isAnyShiftInvalid = () => {
  return shiftList.some(isShiftInvalid);
};


  return (
    <>
      <Container fluid="lg">
        {loadingCreate && <Loader />}
        {loadingLocations ? (
          <Loader />
        ) : errorLocations ? (
          <Message variant="danger">
            {errorLocations?.data?.message || errorLocations.error}
          </Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Card className="mb-4 custom-card-bg">
              <Card.Header className="fw-bold fs-4">
                Create Shift{calculateTotalShifts() > 1 ? `s (${calculateTotalShifts()} total)` : ''}
              </Card.Header>
              <Card.Body>
                <Tabs
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className="mb-4"
                >
                  <Tab eventKey="basic" title="Basic Information">
                    {/* Top Row: Hospital Location, Category, Reason */}
                    <Row className="mb-4">

                       <Form.Group controlId="isOvertime" className="mb-3">
  <Form.Check
    type="checkbox"
    label={<span className="fw-bold">Overtime Shift</span>}
    checked={isOvertime}
    onChange={(e) => setIsOvertime(e.target.checked)}
  />
</Form.Group>


                      <Col lg={4}>
                        <Form.Group controlId="hospitalLocationId">
                          <Form.Label className="fw-bold">Hospital Location</Form.Label>
                          <Form.Select
                            value={hospitalLocationId}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              setHospitalLocationId(selectedId);
                              const selectedLocation = hospitalLocations.find(
                                (loc) => loc._id === selectedId
                              );
                              setWardDepartmentArea(selectedLocation?.wardDepartmentArea || '');
                            }}
                            required
                            size="lg"
                          >
                            <option value="">Select Hospital Location...</option>
                            {hospitalLocations.map((location) => (
                              <option key={location._id} value={location._id}>
                                {location.wardDepartmentArea} 
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col lg={4}>
                        <Form.Group controlId="categoryOfStaff">
                          <Form.Label className="fw-bold">Category of Staff</Form.Label>
                          <Form.Select
                            value={categoryOfStaff}
                            onChange={(e) => setCategoryOfStaff(e.target.value)}
                            required
                            size="lg"
                          >
                            <option value="">Select Category...</option>
                            {CATEGORY_OF_STAFF.map((c) => (
                              <option key={c.value} value={c.value}>
                                {c.label}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col lg={4}>
                        <Form.Group controlId="reasonForRequest">
                          <Form.Label className="fw-bold">Reason for Request</Form.Label>
                          <Form.Select
                            value={reasonForRequest}
                            onChange={(e) => {
                              setReasonForRequest(e.target.value);
                              setSpecialsReason('');
}}
                            required
                            size="lg"
                          >
                            <option value="">Select Reason...</option>
                            {REASON_FOR_REQUEST.map((r) => (
                              <option key={r.value} value={r.value}>
                                {r.label}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                       

                      </Col>

                      {/* Specials/Cohorts sub-reason — only shown for '1-1 special' or 'Cohorts' */}
                            {SPECIALS_TRIGGER_REASONS.some(
                              (r) => reasonForRequest.toLowerCase() === r.toLowerCase()
                            ) && (
                              <Col lg={4}>
                                <Form.Group controlId="specialsReason">
                                  <Form.Label className="fw-bold">
                                    Specials / Cohorts Reason <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Select
                                    value={specialsReason}
                                    onChange={(e) => setSpecialsReason(e.target.value)}
                                    required
                                    size="lg"
                                  >
                                    <option value="">Select reason...</option>
                                    {SPECIALS_REASON.map((r) => (
                                      <option key={r.value} value={r.value}>
                                        {r.label}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Text className="text-muted">
                                    Required for 1-1 Special and Cohort requests
                                  </Form.Text>
                                </Form.Group>
                              </Col>
                            )}
                     
                    </Row>

                    

                    {/* Middle Row: Reason Details, Options, and Shifts per Day */}
                    <Row className="mb-4">
                      {/* Reason for Request Details */}
                      <Col lg={6}>
                        <Form.Group controlId="reasonForRequestDetails">
                          <Form.Label className="fw-bold">Reason for Request Details</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            value={reasonForRequestDetails}
                            onChange={(e) => setReasonForRequestDetails(e.target.value)}
                            placeholder="Provide details about why this shift is needed..."
                          />
                        </Form.Group>
                      </Col>

                      {/* Checkboxes and ECC Number */}
                      <Col lg={6}>
                        <Row>
                          {/* Checkboxes - Left side */}
                          <Col lg={6}>
                            <Form.Label className="fw-bold d-block">Options</Form.Label>
                            <div className="border rounded p-3 bg-light">
                              <Form.Group controlId="escort" className="mb-3">
                                <Form.Check
                                  type="checkbox"
                                  label={<span className="fw-bold">Escort Required</span>}
                                  checked={escort}
                                  onChange={(e) => setEscort(e.target.checked)}
                                />
                              </Form.Group>
                              <Form.Group controlId="special">
                                <Form.Check
                                  type="checkbox"
                                  label={<span className="fw-bold">Is this a Special</span>}
                                  checked={special}
                                  onChange={(e) => setSpecial(e.target.checked)}
                                />
                              </Form.Group>
                            </div>
                          </Col>

                          {/* ECC Number and Shifts per Day - Right side */}
                          <Col lg={6}>
                            <Form.Group controlId="eccNumber" className="mb-3">
                              <Form.Label className="fw-bold">ECC Approval Number</Form.Label>
                              <Form.Control
                                type="text"
                                value={eccNumber}
                                onChange={(e) => setEccNumber(e.target.value)}
                                placeholder="Enter ECC number..."
                                size="lg"
                              />
                            </Form.Group>

                            
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {/* Bottom Row: Special Requirements and Comments */}
                    <Row className="mb-4">
                      <Col lg={6}>
                        <Form.Group controlId="specialRequirements">
                          <Form.Label className="fw-bold">Special Requirements</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            value={specialRequirements}
                            onChange={(e) => setSpecialRequirements(e.target.value)}
                            placeholder="Any special equipment, training, or requirements..."
                          />
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group controlId="comments">
                          <Form.Label className="fw-bold">Comments</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            placeholder="Additional notes or comments..."
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Tab>

                  <Tab eventKey="schedule" title="Schedule">
                    <Row className="mb-4">
                      <Col lg={12} className="border rounded p-3 bg-info bg-opacity-10">
                        <Form.Group controlId="shiftPreset">
                          <Form.Label className="fw-bold">Shift Time Preset</Form.Label>
                          <Row className="g-2">
                            {Object.entries(SHIFT_PRESETS).map(([key, preset]) => (
                              <Col lg={3} md={4} sm={6} key={key}>
                                <div className={`border rounded p-2 cursor-pointer ${selectedPreset === key ? 'bg-primary text-white' : 'bg-light'}`}
                                     onClick={() => setSelectedPreset(key)}
                                     style={{cursor: 'pointer'}}>
                                  <Form.Check
                                    type="radio"
                                    id={`preset-${key}`}
                                    label={preset.label}
                                    name="shiftPreset"
                                    checked={selectedPreset === key}
                                    onChange={() => {}}
                                    className="mb-0"
                                  />
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col lg={12} className="border rounded p-3 bg-info bg-opacity-10">
                          <Row className="g-3">


  <Col lg={3}>
    <Form.Group controlId="startDate">
      <Form.Label className="fw-bold">Start Date</Form.Label>
      <Form.Control
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        required
        size="lg"
      />
    </Form.Group>
  </Col>

  <Col lg={3}>
    <Form.Group controlId="endDate">
      <Form.Label className="fw-bold">End Date (Same Day)</Form.Label>
      <Form.Control
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        min={startDate}
        required
        size="lg"
      />
      <Form.Text className="text-muted">
        Same day unless overnight shift
      </Form.Text>
    </Form.Group>
  </Col>

  <Col lg={3}>
    <Form.Group controlId="startTime">
      <Form.Label className="fw-bold">Start Time</Form.Label>
      <Form.Control
        type="time"
        value={startTime}  
        onChange={(e) => setStartTime(e.target.value)}  
        required
        size="lg"
      />
    </Form.Group>
  </Col>

  <Col lg={3}>
    <Form.Group controlId="endTime">
      <Form.Label className="fw-bold">End Time</Form.Label>
      <Form.Control
        type="time"
        value={endTime} 
        onChange={(e) => setEndTime(e.target.value)}  
        required
        size="lg"
      />
    </Form.Group>
    </Col>
    </Row>
  </Col>
</Row>
                                            <Row className="mb-4">
                                            <Col lg={12} className="border rounded p-3 bg-info bg-opacity-10">
                                            <Form.Group controlId="recurrenceType">
                                              <Form.Label className="fw-bold">Recurrence Pattern</Form.Label>
                                              
                    
                                              <Row className="g-2 flex-nowrap">
                                                {Object.values(RECURRENCE_OPTIONS).map((option) => (
                                                  <Col key={option.value}>
                                                    <div 
                                                      className={`border rounded p-2 cursor-pointer ${recurrenceType === option.value ? 'bg-primary text-white' : 'bg-light'}`}
                                                      onClick={() => setRecurrenceType(option.value)}
                                                      style={{cursor: 'pointer'}}
                                                    >
                                                      <Form.Check
                                                        type="radio"
                                                        id={`recurrence-${option.value}`}
                                                        label={option.label}
                                                        name="recurrenceType"
                                                        checked={recurrenceType === option.value}
                                                        onChange={() => {}}
                                                        className="mb-0 text-nowrap"
                                                      />
                                                    </div>
                                                  </Col>
                                                ))}
                                              </Row>
                    
                                            </Form.Group>
                                          </Col>
                                        </Row>
                    
                                        {recurrenceType !== 'NONE' && (
                                          <>
                                            <Row className="mb-4">
                                            <Col lg={12} className="border rounded p-3 bg-info bg-opacity-10">
                                              <Row className="g-3">
                                                <Col md={6}>
                                                  <Form.Group controlId="recurrenceEndDate">
                                                    <Form.Label className="fw-bold">Recurrence End Date</Form.Label>
                                                    <Form.Control
                                                      type="date"
                                                      value={recurrenceEndDate}
                                                      onChange={(e) => setRecurrenceEndDate(e.target.value)}
                                                      min={startDate}
                                                      size="lg"
                                                    />
                                                    <Form.Text className="text-muted">
                                                      Leave empty for no end date
                                                    </Form.Text>
                                                  </Form.Group>
                                                </Col>
                    
                                                <Col md={6}>
                                                  <Form.Group controlId="recurrenceOccurrences">
                                                    <Form.Label className="fw-bold">Number of Occurrences</Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      min="1"
                                                      max="365"
                                                      value={recurrenceOccurrences}
                                                      onChange={(e) => setRecurrenceOccurrences(Math.max(1, parseInt(e.target.value) || 1))}
                                                      size="lg"
                                                    />
                                                    <Form.Text className="text-muted">
                                                      Leave as 1 for unlimited (until end date)
                                                    </Form.Text>
                                                  </Form.Group>
                                                </Col>
                                              </Row>
                                            </Col>
                                          </Row>





      <Row className="mb-4">
  <Col lg={12}>
    <Form.Label className="fw-bold d-block mb-2">Repeat On Days & Shifts per Day</Form.Label>
    <div className="d-flex flex-wrap gap-3 border rounded p-3 bg-light">
      {DAYS_OF_WEEK.map((day) => (
        <div key={day.value} className="d-flex align-items-center" style={{minWidth: '180px'}}>
          <Form.Check
            type="checkbox"
            id={`day-${day.value}`}
            label={<span className="fw-bold me-2">{day.label}</span>}
            checked={selectedDays.includes(day.value)}
            onChange={() => handleDayToggle(day.value)}
            disabled={recurrenceType === 'NONE'}
            className="me-2"
          />
          <Form.Control
            type="number"
            min="0"
            max="10"
            value={shiftsPerDay[day.value]}
            onChange={(e) => handleShiftsPerDayChange(day.value, e.target.value)}
            size="sm"
            disabled={recurrenceType === 'NONE' || !selectedDays.includes(day.value)}
            className={!selectedDays.includes(day.value) && recurrenceType !== 'NONE' ? 'bg-light text-muted' : ''}
            style={{ width: '70px' }}
          />
        </div>
      ))}
    </div>
    <div className="d-flex justify-content-between mt-2">
      <Form.Text className="text-muted">
        Select days and set number of shifts (0 to skip)
      </Form.Text>
      {recurrenceType !== 'NONE' && (
        <Form.Text className="text-primary fw-bold">
          Total weekly: {DAYS_OF_WEEK.reduce((total, day) => 
            total + (selectedDays.includes(day.value) ? (shiftsPerDay[day.value] || 0) : 0), 0
          )} shifts
        </Form.Text>
      )}
    </div>
  </Col>
</Row>
                      </>
                    )}


                     {FORTY_EIGHT_HOUR_REASONS.some(
  (r) => reasonForRequest.toLowerCase() === r.toLowerCase()
) && (
  <Row className="mb-4">
    <Col lg={12}>
      <div className="alert alert-warning d-flex align-items-center">
        <i className="bi bi-clock-history fs-4 me-3"></i>
        <div>
          <strong>
            {new Date().getDay() === 5 ? '720' : '720'}-Hour Limit Applied
          </strong>
          <p className="mb-0 mt-1">
            Requests for <strong>{reasonForRequest}</strong> can only be
            created for shifts starting within the next{' '}
            <strong>{new Date().getDay() === 5 ? '720' : '720'} hours</strong>
            {new Date().getDay() === 5 && (
              <span className="ms-1">(extended to 720 hours as today is Friday)</span>
            )}.
            Any shifts beyond that window will be automatically excluded.
          </p>
        </div>
      </div>
    </Col>
  </Row>
)}



                    <Row className="mb-4">
                      <Col lg={12}>
                       
<div className="alert alert-primary">
  <div className="d-flex align-items-center">
    <div className="me-3">
      <i className="bi bi-info-circle fs-4"></i>
    </div>
    <div>
      <strong className="fs-5">Summary:</strong>
      <div className="mt-1">
        This will create <strong className="fs-5">{calculateTotalShifts()}</strong> shift{calculateTotalShifts() > 1 ? 's' : ''}
        {recurrenceType !== 'NONE' && <span> with <strong>{recurrenceType.toLowerCase()}</strong> recurrence</span>}
      </div>
      {recurrenceType !== 'NONE' && (
        <div className="mt-2">
          <strong>Shifts per week:</strong>
          <ul className="mb-0 mt-1">
            {DAYS_OF_WEEK.map(day => {
              const count = shiftsPerDay[day.value];
              if (selectedDays.includes(day.value) && count > 0) {
                return (
                  <li key={day.value}>
                    {day.label}: <strong>{count}</strong> shift{count > 1 ? 's' : ''}
                  </li>
                );
              }
              return null;
            })}
          </ul>
          <div className="mt-2 text-muted small">
            Total weekly: <strong>
              {DAYS_OF_WEEK.reduce((total, day) => 
                total + (selectedDays.includes(day.value) ? (shiftsPerDay[day.value] || 0) : 0), 0
              )} shifts/week
            </strong>
          </div>
        </div>
      )}
    </div>
  </div>
</div>
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>

                <div className="d-flex justify-content-between pt-3 border-top">
                  <Button 
                    variant="secondary" 
                    onClick={() => navigate('/admin/shifts')}
                    size="lg"
                  >
                    Cancel

                  </Button>
                  <Button type="submit" variant="primary" size="lg"  disabled={isSubmitting || loadingCreate}>

                    {isSubmitting ? 'Creating...' : `Review & Create ${calculateTotalShifts() > 1 ? `${calculateTotalShifts()} Shifts` : 'Shift'}`}

                    
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Form>
        )}

        {/* Confirmation Modal */}
{/* Confirmation Modal */}
<Modal 
  show={showConfirmation} 
  onHide={() => !isSubmitting && setShowConfirmation(false)}
  size="xl"
  backdrop="static"
  keyboard={!isSubmitting}
>
  <Modal.Header closeButton={!isSubmitting}>
    <Modal.Title>
      {saveSuccess ? 'Success!' : `Confirm Shift Creation (${shiftList.length} Shifts)`}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {saveSuccess ? (
      <div className="text-center py-5">
        <div className="text-success mb-3">
          <i className="bi bi-check-circle-fill" style={{ fontSize: '4rem' }}></i>
        </div>
        <h4>Shifts Created Successfully!</h4>
        <p className="text-muted">Redirecting to shifts list...</p>
      </div>
    ) : (
      <>
        {/* Selection Controls */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-2">
            <Form.Check
              type="checkbox"
              id="select-all-shifts"
              label="Select All"
              checked={selectedShifts.length === shiftList.length && shiftList.length > 0}
              onChange={handleSelectAll}
              disabled={shiftList.length === 0}
            />
            {selectedShifts.length > 0 && (
              <>
                <span className="text-muted">|</span>
                <span className="text-primary fw-bold">
                  {selectedShifts.length} shift{selectedShifts.length > 1 ? 's' : ''} selected
                </span>
                <span className="text-muted">|</span>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleRemoveMultiple(selectedShifts)}
                  disabled={isSubmitting}
                >
                  <i className="bi bi-trash me-1"></i>
                  Remove Selected
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleClearSelection}
                >
                  Clear Selection
                </Button>
              </>
            )}
          </div>
          <div>
            <Button
              variant="outline-info"
              size="sm"
              onClick={() => {
                // Add functionality to export shifts if needed
                toast.info('Export feature coming soon!');
              }}
            >
              <i className="bi bi-download me-1"></i>
              Export
            </Button>
          </div>
        </div>
        
        <div className="alert alert-info mb-4">
          <div className="d-flex align-items-center">
            <div className="me-3">
              <i className="bi bi-info-circle fs-4"></i>
            </div>
            <div>
              <strong>Review, Edit, and Remove Shifts</strong>
              <p className="mb-0 mt-1">
                Click the checkbox to select shifts for bulk removal, or use the trash icon for individual removal.
                {isEditing && (
                  <span className="text-warning ms-2">
                    <i className="bi bi-exclamation-triangle"></i> You have unsaved edits
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
        
        <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <Table striped bordered hover className="table-hover-rows">
            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
              <tr>
                <th width="5%">
                  <Form.Check
                    type="checkbox"
                    checked={selectedShifts.length === shiftList.length && shiftList.length > 0}
                    onChange={handleSelectAll}
                    disabled={shiftList.length === 0}
                  />
                </th>
                <th width="5%">#</th>
                <th width="12%">Date</th>
                <th width="10%">Day</th>
                <th width="18%">Start Time</th>
                <th width="18%">End Time</th>
                <th width="12%">Duration</th>
                <th width="15%">Status</th>
                <th width="5%">Action</th>
              </tr>
            </thead>
            <tbody>
  {shiftList.length === 0 ? (
    <tr>
      <td colSpan="9" className="text-center py-4">
        <div className="text-muted">
          <i className="bi bi-calendar-x" style={{ fontSize: '2rem' }}></i>
          <p className="mt-2">No shifts to display. All shifts have been removed.</p>
          <Button
            variant="outline-primary"
            onClick={handleResetChanges}
          >
            <i className="bi bi-arrow-counterclockwise me-1"></i>
            Restore Original Shifts
          </Button>
        </div>
      </td>
    </tr>
  ) : (
    shiftList.map((shift, index) => {
      // Define validation logic INSIDE the map function
      const isValidShift = () => {
  const start = new Date(`${shift.startDate}T${shift.startTime}`);
  const end = new Date(`${shift.endDate}T${shift.endTime}`);
  
  // Handle overnight shifts
  if (end < start) {
    // Check if it's the same calendar day (overnight shift)
    if (shift.startDate === shift.endDate) {
      const adjustedEnd = new Date(end);
      adjustedEnd.setDate(adjustedEnd.getDate() + 1);
      return adjustedEnd > start;
    }
    return false;
  }
  
  return end > start;
};
      
      const isValid = isValidShift();
      const isSelected = selectedShifts.includes(index);
      const isEdited = shiftList[index] !== originalShiftList[index];
      
      return (
        <tr 
          key={shift.id} 
          className={`${!isValid ? 'table-warning' : ''} ${isSelected ? 'table-primary' : ''} ${isOvernightShift(shift) ? 'overnight-shift' : ''}`}
          onClick={(e) => {
            // Only select if clicking on the row but not on inputs or delete button
            if (!e.target.closest('input') && !e.target.closest('button')) {
              handleShiftSelect(index);
            }
          }}
          style={{ cursor: 'pointer' }}
        >
          <td>
            <Form.Check
              type="checkbox"
              checked={isSelected}
              onChange={() => handleShiftSelect(index)}
              onClick={(e) => e.stopPropagation()}
            />
          </td>
          <td className="fw-bold">{index + 1}</td>
          <td>
            <Form.Control
              type="date"
              value={shift.startDate}
              onChange={(e) => handleShiftUpdate(index, 'startDate', e.target.value)}
              size="sm"
              onClick={(e) => e.stopPropagation()}
            />
          </td>
          <td className="fw-bold">{getDayOfWeek(shift.startDate)}</td>
          <td>
            <Form.Control
              type="time"
              value={shift.startTime}
              onChange={(e) => handleShiftUpdate(index, 'startTime', e.target.value)}
              size="sm"
              isInvalid={!isValid}
              onClick={(e) => e.stopPropagation()}
            />
            {!isValid && (
              <Form.Control.Feedback type="invalid">
                {shift.startTime > shift.endTime && shift.startDate === shift.endDate 
                  ? 'Overnight shift detected' 
                  : 'Start must be before end'}
              </Form.Control.Feedback>
            )}
          </td>
          <td>
            <Form.Control
              type="time"
              value={shift.endTime}
              onChange={(e) => handleShiftUpdate(index, 'endTime', e.target.value)}
              size="sm"
              isInvalid={!isValid}
              onClick={(e) => e.stopPropagation()}
            />
            {shift.endTime < shift.startTime && shift.startDate === shift.endDate && (
  <div className="small text-success mt-1">
    <i className="bi bi-moon"></i> Overnight shift ({calculateDuration(shift.startDate, shift.startTime, shift.endDate, shift.endTime)})
  </div>
)}
          </td>
          <td className="fw-bold">
            {calculateDuration(shift.startDate, shift.startTime, shift.endDate, shift.endTime)}
          </td>
          <td>
            {!isValid ? (
              <span className="badge bg-warning text-dark">Invalid</span>
            ) : isEdited ? (
              <span className="badge bg-info">
                {shift.isNewlyAdded ? 'New' : 'Edited'}
              </span>
            ) : (
              <span className="badge bg-secondary">Original</span>
            )}
          </td>
          <td>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveShift(index);
              }}
              disabled={isSubmitting}
              title="Remove this shift"
            >
              <i className="bi bi-trash"></i>
            </Button>
          </td>
        </tr>
      );
    })
  )}
</tbody>
          </Table>
        </div>


               
        <div className="mt-4">
          <Row>
            <Col md={6}>
              <div className="border rounded p-3 bg-light">
                <h6>Shift Summary</h6>
                <ul className="mb-0">
                  <li>Total Shifts: <strong>{shiftList.length}</strong></li>
                  <li>Selected: <strong>{selectedShifts.length}</strong></li>
                  <li>Overnight Shifts: <strong>{shiftList.filter(isOvernightShift).length}</strong></li>
                  <li>Edited Shifts: <strong>{shiftList.filter((shift, idx) => shift !== originalShiftList[idx]).length}</strong></li>
                  
                  <li>Invalid Shifts: <strong>{shiftList.filter(isShiftInvalid).length}</strong></li>
                  <li>Average Duration: <strong>
                    {(() => {
                      if (shiftList.length === 0) return 'N/A';
                      const durations = shiftList.map(s => {
                        const [sh, sm] = s.startTime.split(':').map(Number);
                        const [eh, em] = s.endTime.split(':').map(Number);
                        let ehAdj = eh;
                        if (s.endTime < s.startTime) ehAdj += 24;
                        return (ehAdj * 60 + em) - (sh * 60 + sm);
                      });
                      const avg = durations.reduce((a, b) => a + b, 0) / durations.length;
                      return `${Math.floor(avg / 60)}h ${Math.round(avg % 60)}m`;
                    })()}
                  </strong></li>
                </ul>
              </div>
            </Col>
            <Col md={6}>
              <div className="border rounded p-3 bg-light">
                <h6>Quick Actions</h6>
                <div className="d-flex flex-wrap gap-2 mb-2">


                 <Button
  variant="outline-danger"
  size="sm"
  onClick={() => {
    const invalidShifts = shiftList
      .map((shift, idx) => ({ shift, idx }))
      .filter(({ shift }) => isShiftInvalid(shift))
      .map(({ idx }) => idx);
    
    if (invalidShifts.length > 0) {
      handleRemoveMultiple(invalidShifts);
      toast.info(`Removed ${invalidShifts.length} invalid shift(s)`);
    } else {
      toast.info('No invalid shifts found');
    }
  }}
  disabled={isSubmitting || shiftList.length === 0}
>
  <i className="bi bi-x-circle me-1"></i>
  Remove Invalid
</Button>



                  <Button
                    variant="outline-warning"
                    size="sm"
                    onClick={() => {
                      const weekendShifts = shiftList
                        .map((shift, idx) => ({ shift, idx }))
                        .filter(({ shift }) => {
                          const day = new Date(shift.startDate).getDay();
                          return day === 0 || day === 6; // Sunday (0) or Saturday (6)
                        })
                        .map(({ idx }) => idx);
                      
                      if (weekendShifts.length > 0) {
                        handleRemoveMultiple(weekendShifts);
                        toast.info(`Removed ${weekendShifts.length} weekend shift(s)`);
                      } else {
                        toast.info('No weekend shifts found');
                      }
                    }}
                    disabled={isSubmitting || shiftList.length === 0}
                  >
                    <i className="bi bi-calendar-week me-1"></i>
                    Remove Weekends
                  </Button>
                  

<Button
  variant="outline-success"
  size="sm"
  onClick={() => {
    // Find the last date in the sorted list
    let lastDate = new Date(startDate);
    if (shiftList.length > 0) {
      // Get the last date from existing shifts
      const sortedShifts = sortShiftsByDate(shiftList);
      const lastShift = sortedShifts[sortedShifts.length - 1];
      lastDate = new Date(lastShift.endDate); // Use end date to handle overnight shifts
    }
    
    //const newDateStr = lastDate.toISOString().split('T')[0];
    const newDateStr = toLocalDateStr(lastDate);
    
    // Create base shift
    const newShift = {
      id: `${newDateStr}-${startTime}-${endTime}-${shiftList.length}-${Date.now()}`,
      startDate: newDateStr,
      startTime,
      endTime,
      shiftNumber: shiftList.length + 1,
      isNewlyAdded: true
    };
    
    // Auto-adjust for overnight shifts
    const adjustedShift = autoAdjustOvernightShift(newShift);
    
    // Add the new shift and sort the list
    const updatedShifts = sortShiftsByDate([...shiftList, adjustedShift]);
    setShiftList(updatedShifts);
    setIsEditing(true);
    toast.success('New shift added at the end of the list');
  }}
  disabled={isSubmitting || shiftList.length >= 50}
>
  <i className="bi bi-plus-circle me-1"></i>
  Add Shift
</Button>



                </div>
                <p className="small text-muted mb-0 mt-2">
                  <i className="bi bi-lightbulb me-1"></i>
                  Tip: Click on a row to select it, or click checkboxes for precise selection
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </>
    )}
  </Modal.Body>
  <Modal.Footer>
    {!saveSuccess && (
      <>
        <div className="me-auto">
          {selectedShifts.length > 0 && (
            <span className="text-primary fw-bold me-3">
              {selectedShifts.length} shift{selectedShifts.length > 1 ? 's' : ''} selected
            </span>
          )}
          <Button 
            variant="outline-secondary" 
            onClick={handleResetChanges}
            disabled={isSubmitting || (!isEditing && shiftList.length === originalShiftList.length)}
          >
            <i className="bi bi-arrow-counterclockwise me-1"></i>
            {shiftList.length === 0 ? 'Restore All' : 'Reset Changes'}
          </Button>
        </div>
        <Button 
          variant="secondary" 
          onClick={() => setShowConfirmation(false)}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={createShifts}
          disabled={
          isSubmitting || 
          shiftList.length === 0 ||
          isAnyShiftInvalid()
        }
        >
          {isSubmitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Creating Shifts...
            </>
          ) : (
            <>
              <i className="bi bi-check-circle me-1"></i>
              Confirm & Create {shiftList.length} Shift{shiftList.length > 1 ? 's' : ''}
            </>
          )}
        </Button>
      </>
    )}
  </Modal.Footer>
</Modal>


      </Container>
    </>
  );
};

export default ShiftCreateScreen;